import { Alert, Button, CircularProgress, Stack, Typography } from '@mui/material';
import type { BillingDemoDetails } from 'api-client';
export default function BillingDemoPanel({
  title,
  data,
  loading,
  error,
  onRetry,
}: {
  title: string;
  data: BillingDemoDetails | null;
  loading: boolean;
  error: string | null;
  onRetry: () => void;
}) {
  return (
    <Stack spacing={3}>
      <Typography component="h1" variant="h4">
        {title}
      </Typography>
      {loading && <CircularProgress aria-label="Loading subscription access" />}
      {error && (
        <Alert
          severity="error"
          action={
            <Button color="inherit" onClick={onRetry}>
              Retry
            </Button>
          }
        >
          {error}
        </Alert>
      )}
      {data && (
        <>
          {!data.billingEnabled && (
            <Alert severity="info">
              In-app billing is disabled during beta. Beta billing is handled separately through agreements.
            </Alert>
          )}
          <Alert severity={data.hasAccess ? 'success' : 'warning'}>
            {data.hasAccess
              ? 'Subscription access check passed.'
              : data.reason || 'An active subscription is required.'}
          </Alert>
          {data.subscriptionName && <Typography>Current subscription: {data.subscriptionName}</Typography>}
        </>
      )}
    </Stack>
  );
}
